@if (isLoading()) {
  <div class="or-mt-12-px or-mx-16-px">
    @for (item of skeletonItems; track item) {
      <div class="dashboard-game-skeleton or-skeleton-animated or-mb-12-px"></div>
    }
  </div>
} @else if (hasAnyGames()) {
  <div class="or-mt-12-px">
    @for (game of hostedGames(); track game.gameId) {
      <div class="or-mb-12-px">
        <lib-game-card-v2
          [game]="game"
          [redirectType]="gameRedirectType.HOSTED"
          [showShareButton]="true"
          [badgeMode]="badgeMode.HOST"
          [showHostDetails]="true"></lib-game-card-v2>
      </div>
    }
    @for (game of playerApprovedGames(); track game.gameId) {
      <div class="or-mb-12-px">
        <lib-game-card-v2
          [game]="game"
          [redirectType]="gameRedirectType.GAME"
          [showShareButton]="true"
          [badgeMode]="badgeMode.PLAYER"
          [showHostDetails]="true"></lib-game-card-v2>
      </div>
    }
    @for (game of playerWaitingGames(); track game.gameId) {
      <div class="or-mb-12-px">
        <lib-game-card-v2
          [game]="game"
          [redirectType]="gameRedirectType.GAME"
          [showShareButton]="true"
          [badgeMode]="badgeMode.PLAYER"
          [showHostDetails]="true"></lib-game-card-v2>
      </div>
    }
  </div>
}
